import React, { useEffect, useState } from 'react';
import VideoModal from '../components/VideoModal'
import websso from '../assets/images/Vectorwebsso.png'
import sync from '../assets/images/Vectorsync.png'
import social from '../assets/images/Vectorsocial.png'
import selfService from '../assets/images/VectorselfService.png'
import progressive from '../assets/images/Vectorprogressive.png'
import Passwordless from '../assets/images/Vectorpasswordless.png'

import sso from '../assets/images/Vectorsso.png'
import mfa from '../assets/images/Vectormfa.png'
import network from '../assets/images/Vectornetwork.png'
import lifecycle from '../assets/images/Vectorlifecycle.png'
import vpn from '../assets/images/Vectorvpn.png'
import brokering from '../assets/images/Vectorbrokering.png'
import adaptive from '../assets/images/Vectoradaptive.png'
import YouTube from 'react-youtube';
import { AiFillPieChart, AiOutlineAudit, AiOutlineClockCircle, AiOutlinePieChart } from "react-icons/ai";
import { MdOutlineFingerprint, MdOutlineVerifiedUser, MdOutlineVideoCameraFront, MdVerifiedUser } from 'react-icons/md';


const CommonDemoPage = (props) => {

  const [open, setOpen] = useState(false);
  const [demoData, setDemoData] = useState();
  const handleOpen = (videoData) => {
    setDemoData(videoData);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const opts = {
    height: '337',
    width: '100%',
    playerVars: {
      //   https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      rel: 0
    },
  };

  const playPause = (event) => {
    // console.log("event", event.target.pauseVideo())
    // event.target.pauseVideo();
  }


  return (
    <>
      <div className='w-100 py-3' style={{ height: '88vh', overflowX:'hidden' }}>
        <div className='mx-2 h-auto'>
          <div className='backButton d-flex align-items-center' onClick={() => window.history.back()}>
            <span class="material-symbols-rounded text-dark">
              keyboard_arrow_left
            </span>
            <p className='mb-0'>Back</p>
          </div>
        </div>
        <h4 className='text-center mt-3 h-auto lh-base text-secondary-emphasis fw-bold mx-4 mx-md-0 my-4 my-md-0'>{props.title}</h4>
        <h5 className='text-center mb-3 h-auto text-secondary'>{props.subtext}</h5>
        <div className='row justify-content-center h-75 align-items-center mx-sm-5 my-md-5'>
          <div className='col-12'>
            <div className='row justify-content-between'>
              <div className='col-6 d-flex align-items-center justify-content-center d-md-flex d-none'>
                <div className='col-12 col-xl-10'>
                  <YouTube className='w-100' videoId={props?.videoId} opts={opts} onReady={playPause} />
                </div>
              </div>
              <div className='col-md-6 col-12 d-flex justify-content-center'> 
                <div className='row justify-content-start px-5 px-sm-0 ps-md-5' style={{height:"fit-content"}}>
                  {props?.data?.map((item) => {
                    if(item.video == false){
                    return (
                      <div className={props?.data?.length <=6 ? "col-md-12 ms-0 ms-sm-4 ms-md-0 ms-xl-4 py-1 col-sm-5 px-0 px-lg-0 px-xl-5" : "col-lg-5 col-md-12 ms-0 ms-sm-4 ms-md-0 ms-xl-4 py-1 col-sm-5"}>
                        <div className='d-flex justify-content-start'>
                          <div className='p-2 d-flex align-items-center'>
                            <div className="align-items-center text-14">
                              <div className="d-flex justify-content-center bg-primary align-items-center me-3 rounded-circle" style={{height: "40px", width: "40px"}} >
                                  {item.icon}
                              </div>
                            </div>
                            <div>
                                <span style={{fontWeight:500, fontSize:'17px'}}>
                                    {item.title}
                                </span>
                            </div>
                        </div>
                        </div>
                      </div>
                    )}
                    else{
                      return (
                        <div className={props?.data?.length <=6 ? "col-md-12 ms-0 ms-sm-4 ms-md-0 ms-xl-4 py-1 col-sm-5 px-0 px-lg-0 px-xl-5" : "col-lg-6 col-xl-5 col-md-12 ms-0 ms-sm-4 ms-md-0 ms-xl-4 py-1 col-sm-5"}>
                          <div className='d-flex justify-content-start'>
                            <div className='p-2 d-flex align-items-center service-button' onClick={() => handleOpen({ "text": item.title, "videoId": item.videoId, "videoType": item.videoType })} style={{ width: 'fit-content' }}>
                              <div className="align-items-center text-14">
                                <div className="d-flex justify-content-center bg-primary align-items-center me-3 rounded-circle" style={{height: "40px", width: "40px"}} >
                                    {item.icon}
                                </div>
                              </div>
                              <div>
                                  <span style={{fontWeight:500, fontSize:'17px'}}>
                                      {item.title}
                                  </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  })}

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <VideoModal
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        videoData={demoData}
      />
    </>
  )
}

export default CommonDemoPage